// Elements
require("webstrap/type");
require("grid");

// Styles
require("./img-text.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/img-text/index.js
 ** module id = 167
 ** module chunks = 0 1
 **/